module.exports = __webpack_public_path__ + "static/enjoy-relax-850686e4c9afac235f2bc1a9b955188d.png";